<template>
  <div class="inProcess" v-if="loadingProcesses">
    <img
      class="inProcess__img"
      src="@/assets/imgs/gifs/loading.gif"
      alt="loading..."
      >
    <span>{{ loadingProcesses.message }}...</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'loadingProcesses'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import '~$scss/globals';

.inProcess {
  position: fixed;
  bottom: 20px;
  right: 20px;
  height: 46px;
  background: white;
  border: 1px solid $borderColor1;
  padding: {
    left: 7px;
    right: 10px;
    top: 4px;
  }
  z-index: 10000;
  &__img {
    width: 35px;
    height: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InProcess.vue